<template>
  <div>
    <zj-layout-container>
      <zj-layout-header style="padding-top: 50px">
        开始时间：
        <el-date-picker
          v-model="chooseStartDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :clearable="false"
          @change="changeBegin"
          placeholder="选择日期"
          >>
        </el-date-picker>
        <span style="margin-left: 30px">结束时间：</span>
        <el-date-picker
          v-model="chooseEndDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :clearable="false"
          @change="changeEnd"
          placeholder="选择日期"
          >>
        </el-date-picker>
        <el-button size="medium" style="margin-left: 30px" @click="search"
          >查询</el-button
        >
      </zj-layout-header>
      <zj-layout-main>
        <div class="echart">
          <div class="echart_2">
            <div>
              操作日志统计
             <LineEchart3
                title=""
                xAxisName="日期"
                yAxisName="数量"
                :legendData="legendData"
                :chartData="logData"
                v-if="logData.days"
              ></LineEchart3>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script>
import { logStatics } from "@/api/src/bigData";
export default {
  controller: "UI",
  action: "LogOperationTrend",
  name: "LogOperationTrend",
  data() {
    return {
         legendData: [new Date().getFullYear(), new Date().getFullYear()-1],
    //   chooseStartDate: new Date().format("yyyy-MM-dd"),
    //   chooseEndDate: new Date().format("yyyy-MM-dd"),
      chooseStartDate:"",
      chooseEndDate: "",
      logData: {    
        days:"",
        data:"",
      },
      ticketTypeData: [],
      params: {
        status:0,
        // district: this.CNF("app.districtCode"),
        // districtCode: this.CNF("app.districtCode"),
        // polityType: 3,
        // timeType: "year",
        // timeValue: 1,
      },
    };
  },
  created() {
    this.search();
  },
  methods: {
    changeBegin() {
      console.log("this.chooseStartDate===========")
      console.log(this.chooseStartDate)
      if (this.chooseStartDate && this.chooseEndDate) {
        if (
          new Date(this.chooseStartDate).getTime() >
          new Date(this.chooseEndDate).getTime()
        ) {
          this.chooseStartDate = "";
          this.$message({
            type: "warning",
            message: "开始时间不能大于结束时间",
          });
        }
      }
    },
    changeEnd() {
      if (this.chooseStartDate && this.chooseEndDate) {
        if (
          new Date(this.chooseStartDate).getTime() >
          new Date(this.chooseEndDate).getTime()
        ) {
          this.chooseEndDate = "";
          this.$message({
            type: "warning",
            message: "开始时间不能大于结束时间",
          });
        }
      }
    },
    search() {
      this.params.startDate = this.chooseStartDate;
      this.params.endDate = this.chooseEndDate;
      logStatics(this.params).then((res) => {
        // console.log(res)
        if (res.data) {
          let dataList = res.data || [];
          var XData = [];
          var datas=[];
          dataList.map((item) => {
              const { date, count } = item;
              XData.push(date);
              datas.push(count)
          });
            this.logData.data=datas;
            this.logData.days = XData;
            // console.log( this.logData)
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.datelabel {
  border-right: 3px solid #2bc5ff;
  padding: 0 1rem;
}
.echart {
  position: relative;
  width: 100%;
  height: 100%;
}
.echart_1,
.echart_2 {
  width: 100%;
  height: 60%;
}
.echart_1 {
  margin-bottom: 15px;
}
.echart_2 {
  margin-top: 15px;
}
.echart_1 > div,
.echart_2 > div {
  float: left;
  width: 30%;
  height: 100%;
  color: #2bc5ff;
  font-weight: bold;
  text-align: center;
}
.echart_2 > div {
  width: 50%;
}
</style>